export default "__VITE_ASSET__BNkx98iv__"